import { camelCase } from 'lodash'

export const renderDataLayerObject = (content = {}) =>
  Object.assign(...Object.keys(content).map((key) => ({ [camelCase(key)]: content[key] })))
